<app-global-spinner></app-global-spinner>
<div class="container" *ngIf="isProductList">
    <div class="app-main-content-holder" [ngClass]="{ 'isHeaderShow': !layoutState().headerVisible }">
        <router-outlet *ngIf="!isIframe"></router-outlet>
    </div>
</div>
<div class="container" *ngIf="!isProductList">
    <app-header *ngIf="isLoaded && layoutState().headerVisible && appComponentLoaded"></app-header>
    <app-full-screen-header *ngIf="layoutState().fullHeaderVisible"></app-full-screen-header>
    <div class="app-main-content row"
        [ngClass]="{ 'isHeaderShow': !layoutState().headerVisible, 'isRolePlayActive': layoutState().rolePlayActive, 'hide-sidebar': !layoutState().sidebarCollapsed, 'show-sidebar': layoutState().sidebarCollapsed, 'sidebar-collapsed': layoutState().sidebarCollapsed }">
        <div class="app-left-content" *ngIf="isLoaded" [ngClass]="layoutState().sidebarVisible ? 'show' : 'hidden'">
            <app-sidebar-chatbot *ngIf="appComponentLoaded"></app-sidebar-chatbot>
        </div>
        <div class="app-right-content">
            <app-maintenance-notification></app-maintenance-notification>
            <router-outlet *ngIf="!isIframe"></router-outlet>
        </div>
    </div>
</div>